module.exports = __webpack_public_path__ + "img/chat-left.c116c66f.svg";